export default __webpack_public_path__ + "static/media/flag.79f80263.svg";